import * as types from '../types'
const state = {
  main_orderConfirm: JSON.parse(localStorage.getItem('orderConfirm')) || {},
  main_orderConfirmstate: JSON.parse(localStorage.getItem('main_orderConfirmstate')) || false
}
const actions = {
  set_orderConfirm({commit, state}, res) {
    localStorage.setItem('orderConfirm',res);
    commit(types.SET_ORDERCONFIRM_SET, res);
    commit(types.SET_ORDERCONFIRM_SET_STATE, true);
    localStorage.setItem('main_orderConfirmstate', true);
  },
  del_orderConfirm({commit, state}, res) {
    localStorage.removeItem(res);
    commit(types.SET_ORDERCONFIRM_SET, res);
    commit(types.SET_ORDERCONFIRM_SET_STATE, false);
    localStorage.setItem(res, false);
  }

}
const getters = {
  main_orderConfirm: state => state.main_orderConfirm,
  main_orderConfirmstate: state => state.main_orderConfirmstate
}

const mutations = {
  [types.SET_ORDERCONFIRM_SET](state, res) {
    state.main_orderConfirm = res
  },
  [types.SET_ORDERCONFIRM_SET_STATE](state, res) {
    state.main_orderConfirmstate = res
  }
}
export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/seek.js